
import { orderRecordDetail } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { formatNum } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  },
  filters: {
    formatNum(value: string) {
      return formatNum(value);
    }
  }
})
export default class extends Vue {
  menus: any[] = [
    {
      title: '提交记录',
      isOpen: true,
      child: [
        {
          id: 1,
          title: '代打印',
          link: '/user',
          name: 'user'
        },
        {
          id: 11,
          title: '耗材定制',
          link: '/coupon',
          name: 'coupon'
        }
      ]
    }
  ]

  name: string = ''

  currentIndex: number = Number(this.$route.query.showType)

  infor: any = {}

  created() {
    this.getInforDetails();
  }

  goList(num:number) {
    this.currentIndex = num;
    this.$router.push(
      `/consumables-orderlist?currentIndex=${this.currentIndex}`
    );
  }

  async getInforDetails() {
    const { showType, id } = this.$route.query;
    const res: any = await orderRecordDetail({
      showType,
      id
    });
    this.infor = res.data.data;
  }
}
